import React, { useState, useEffect } from "react";

const LegendNode = ({ data, selected }: any) => {
  const [legends, setLegends] = useState(data?.legends || []);
  const [height, setHeight] = useState(150);

  useEffect(() => {
    setHeight(100 + legends.length * 50);
  }, [legends]);

  const updateLegend = (
    index: number,
    field: "color" | "label",
    value: string
  ) => {
    setLegends((prevLegends: any) => {
      const updatedLegends = [...prevLegends];
      updatedLegends[index] = { ...updatedLegends[index], [field]: value };
      return updatedLegends;
    });
    data.legends = legends;
  };

  return (
    <div
      style={{
        width: "auto",
        height: `auto`,
        background: "#fff",
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "10px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        position: "relative",
      }}
    >
      <h4 style={{ textAlign: "center", marginBottom: "10px" }}>Legenda</h4>
      <div>
        {legends.map((legend: any, index: number) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "8px",
            }}
          >
            <div
              style={{
                backgroundColor: legend.color,
                marginRight: "10px",
                width: "40px",
                height: "40px",
                borderRadius: "8px",
              }}
            ></div>
            <label
              style={{
                flex: 1,
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "8px",
                backgroundColor: "#f9f9f9",
              }}
            >
              {legend.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LegendNode;
